import { render, staticRenderFns } from "./DirectoryBtn.vue?vue&type=template&id=3570b86b&scoped=true&"
import script from "./DirectoryBtn.vue?vue&type=script&lang=js&"
export * from "./DirectoryBtn.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryBtn.vue?vue&type=style&index=0&id=3570b86b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570b86b",
  null
  
)

export default component.exports